// extracted by mini-css-extract-plugin
var _1 = "ClientNotesMobileFooter_footerDivider__ett9V";
var _2 = "ClientNotesMobileFooter_mobileButtonsContainer__cQPGK";
var _3 = "ClientNotesMobileFooter_submit__Fqqad";
var _4 = "ClientNotesMobileFooter_yellowDot__tdPjA";
export { _1 as "footerDivider", _2 as "mobileButtonsContainer", _3 as "submit", _4 as "yellowDot" }
